import React from "react";
const MessageContext = React.createContext();
MessageContext.displayName = "MessageContext";
export default MessageContext;